import coverPhoto from '../assets/hotspot/celebrationCover/Chaharshanbeh_Suri.jpg';
import mehramImage from '../assets/hotspot/headerImages/mehram-s.jpg';
import celebrationThumbnail1 from '../assets/hotspot/celebrationPerformances/Boland_Baalaa_learn .jpg';
import celebrationThumbnail2 from '../assets/hotspot/celebrationPerformances/mehrnam_boland_baalaa_concert.png';

export const chaharshanbe = {
  celebrationTitle: 'Chaharshanbeh Suri',
  startDate: '03-17',
  endDate: '03-17',
  filterValue: 'chaharshanbeh-suri',
  displayDate: 'Date Varies Each Year',
  celebrationImage: coverPhoto,
  description: 'Chaharshanbeh Suri, or "Scarlet Wednesday," is the first event of Nowruz, the Iranian New Year. During the day, people gather brushwood in an open, unrestricted area outdoors. At sunset, after creating bonfires, they jump over the flames in a purification ritual.',
  celebrationVideos: [
    {
      videoLink: 'https://vimeo.com/1105195705?fl=pl&fe=sh',
      videoImage: celebrationThumbnail1,
      songTitle: 'Boland Baalaa',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Chaharshanbeh Suri',
        },
      ],
      songDescription: '"Boland Baalaa" ("Tall and Pretty") is a song from the Khorasan region in northeastern Iran. The song refers to the experience and feelings of being far away from a loved one, whether in spatial distance or emotional distance, reminding us how much someone can care for another person.',
    },
    {
      videoLink: 'https://vimeo.com/1105197090?fl=pl&fe=vl',
      videoImage: celebrationThumbnail2,
      songTitle: 'Boland Baalaa',
      artistName: 'Mehrnam',
      videoTags: [
        {
          tag: 'Yalda',
        },
        {
          tag: 'Chaharshanbeh Suri',
        },
      ],
    },
  ],
  artistsWhoCelebrate: [
    {
      artistName: 'Mehrnam',
      artistImage: mehramImage,
    },
  ],
};
